export default "__VITE_ASSET__Cjac4Rda__"